import React from 'react';
import ContactsBackground from '../assets/img/contacts/contacts-photo.jpg';
import { ReactComponent as LocationIco } from '../assets/img/icons/location-ico.svg';
import'../css/home-photo.css';

const HomePhoto: React.FC = () => {
  return (
    


    <div className='home-photo'>
        <img src={ContactsBackground} alt='Zdjęcie samochodów, które operowane są przez naszych taksówkarzy' />
        <div className='top-right-text-container'>
            <p>Kontakt</p>
            
        </div>
        <div className='bottom-left-text-container'>
            <LocationIco className='home-photo-svg' /> {/* Location tag icon SVG as a component */}
            <p> Dominikańska 1, Bochnia </p>
        </div>



    </div>
    
    
  );
};

export default HomePhoto;